import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs";
import { Zone } from "src/app/domain/zone";
import { CoreData } from "src/app/tools/core-data/core-data";
import { LoadingTask } from "src/app/tools/ui/loading-task";
import { environment } from "src/environments/environment";
import { BaseService } from "./base.service";

@Injectable({
    providedIn: 'root',
})
export class ZoneService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/zone`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    getZoneList(interventionCode: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${interventionCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getZoneList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Zone[]) => {
                return response.map((item: Zone) => {
                    return Zone.mapFromJSON(item);
                });
            }));
    }
}